<template>
    <div id="app">
        <SidebarLeft></SidebarLeft>
        <div class="master-offset">
            <Navbar></Navbar>
            <transition name="switch-page" mode="out-in">
                <router-view :key="$route.fullPath"></router-view>
            </transition>
        </div>
        <SidebarRight></SidebarRight>
    </div>
</template>

<style lang="scss">
    #app {
    }
</style>

<script>
    import SidebarLeft from "@/components/SidebarLeft.vue";
    import SidebarRight from "@/components/SidebarRight.vue";
    import Navbar from "@/components/Navbar.vue";

    export default {
        name: "App",
        components: {
            SidebarLeft,
            SidebarRight,
            Navbar
        },
        metaInfo: {
            title: 'Robin Jünkersfeld - Editor & Colorist',
            titleTemplate: '%s - Robin Jünkersfeld'
        }
    };
</script>
